import { lazyRouteComponent } from "@tanstack/react-router";
import { Gem } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const GROUPS = ["all", "bullion", "energy", "base", "agri"] as const;
export const INTERVALS = ["1m", "5m"] as const;

export interface CommoditySearch {
  /** The selected commodity (MCX symbol: GOLD, CRUDEOILM, ...). */
  symbol: string;
  group: (typeof GROUPS)[number];
  interval: (typeof INTERVALS)[number];
}

function pick<T extends readonly string[]>(
  list: T,
  v: unknown,
  fallback: T[number],
): T[number] {
  return list.includes(v as string) ? (v as T[number]) : fallback;
}

export function parseCommoditySearch(
  s: Record<string, unknown>,
): CommoditySearch {
  const symbol =
    typeof s.symbol === "string" && /^[A-Za-z0-9]{1,20}$/.test(s.symbol)
      ? s.symbol.toUpperCase()
      : "GOLD";
  return {
    symbol,
    group: pick(GROUPS, s.group, "all"),
    interval: pick(INTERVALS, s.interval, "1m"),
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/commodities",
    proOnly: true,
    title: "Commodities",
    component: lazyRouteComponent(
      () => import("./CommoditiesPage"),
      "CommoditiesPage",
    ),
    nav: { label: "Commodities", icon: Gem, group: "Markets", order: 30 },
    validateSearch: parseCommoditySearch,
  },
];
